module.exports = __webpack_public_path__ + "img/ChurchplusLogo.5d41b522.png";